/**
 * @property {string|null} id
 * @property {string|null} label
 * @property {string} country - ISO3166 country code
 */
export default class Type {
    constructor() {
        this.id = null;
        this.label = null;
        this.country = "FR";
    }

    /**
     * Returns a new `Type` instance hydrated with data from given `api_resource`.
     *
     * @param {object} api_resource
     * @return {Type}
     */
    static fromAPI(api_resource) {
        return Object.assign(new Type(), {
            id: api_resource.id,
            label: api_resource.label,
            country: api_resource.country
        });
    }
}
